// eslint-disable jsx-a11y/anchor-is-valid

import React from 'react'
import PropTypes from 'prop-types'
import Logo from '../../brand/Logo/Logo'
// eslint-disable-next-line import/no-named-as-default
import LinkItem from './LinkItem'

import {
  NavLandscape,
  LogoSection,
  LandscapeNavSection,
  CTASection,
  ButtonNew,
} from './styled'
import Button from '../../atoms/Button/Button'
import { TypeLink } from '../../../utils/types'
import Link from '../../atoms/Link/Link'

export const NavigationLandscape = ({
  links,
  maxWidth,
  isVersionTwo,
  isLoginButtonVisible = true,
  getStartedUrl = 'https://signup.yoco.co.za/',
}) => {
  return (
    <NavLandscape maxWidth={maxWidth}>
      <LogoSection href="/za">
        <Logo />
      </LogoSection>
      <LandscapeNavSection>
        {links && links.map(l => <LinkItem key={l.title || ''} {...l} />)}
      </LandscapeNavSection>

      {!isVersionTwo && (
        <Button kind="green" destination={getStartedUrl}>
          Get started
        </Button>
      )}

      {isVersionTwo && <ButtonNew href={getStartedUrl}>Get started</ButtonNew>}

      {isLoginButtonVisible && (
        <CTASection>
          <Link
            linkText="Login"
            url="https://portal.yoco.co.za/"
            linkColor="#00A2E0"
            hoverColor="#00A2E0"
          />
        </CTASection>
      )}
    </NavLandscape>
  )
}

NavigationLandscape.propTypes = {
  links: PropTypes.arrayOf(TypeLink),
  maxWidth: PropTypes.string,
  isVersionTwo: PropTypes.bool,
  isLoginButtonVisible: PropTypes.bool,
  getStartedUrl: PropTypes.string,
}

export default NavigationLandscape



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/NavigationLandscape.js